import { render, staticRenderFns } from "./ProvidersPriceTable.vue?vue&type=template&id=775e4716&"
import script from "./ProvidersPriceTable.vue?vue&type=script&lang=js&"
export * from "./ProvidersPriceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports